<template>
  <div class="newsletter" v-if="showpopup">
    <div class="exit" @click="showpopup = false; $parent.isNewsletterOpen = false;">
      <img src="/images/icons/close-btn.svg" alt="" />
    </div>
    <div class="overlay"></div>
    <div class="relative content">
      <img :src="config.sidebar_image_url" alt="" />
      <div class="form-container">

          <h1>{{ config.title }}</h1>
          <div class="wysiwyg" v-if="successMessage">
            <p class="message success">{{ successMessage }}</p>
          </div>
          <form @submit.prevent="submitForm" :key="componentKey" v-if="!successMessage">
          <div class="form-top">
            <div class="form-field">
              <input required name="first_name" type="text" v-model="payload.first_name" />
              <label for="">First Name</label>
            </div>
            <div class="form-field">
              <input required name="last_name" type="text" v-model="payload.last_name" />
              <label for="">Last Name</label>
            </div>
            <div class="form-field">
              <input required  name="phone" type="text" v-model="payload.phone" />
              <label for="">Phone</label>
            </div>
            <div class="form-field">
              <input required name="email" type="text" v-model="payload.email" />
              <label for="">Email Address</label>
            </div>
          </div>
          <div class="form-field radio">
            <label>I’m interested in…</label>
            <div
              class="custom-checkbox-radio"
              v-for="(interest, index) in config.areas_of_interest" :key="index"
            >
              <input
                :id="`checkbox-${index}`"
                type="radio"
                :value="interest" v-model="payload.data.interests"
              >
              <span @click="clickCheckbox(`checkbox-${index}`)">{{ interest }}</span>
            </div>
          </div>

          <div class="form-field">
            <vue-recaptcha
              @verify="onVerify"
              @expired="onExpired"
              :sitekey="siteKey">
            </vue-recaptcha>
          </div>
          <p v-if="message">{{ message }}</p>

          <button class="button" :disabled="isDisabled"  @click="submitForm">Send</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  props: {
    showpopup: {
      type: Boolean,
      default: true,
    },
    siteKey: {
      type: String,
      default: true,
    },
    config: {
      type: Object,
      default: true,
    }
  },
  components: {
    VueRecaptcha
  },
  data () {
    return {
      componentKey: 0,
      successMessage: '',
      submissionErrors: [],
      isDisabled: true,
      message: null,
      isVerified: false,
      payload: {}
    }
  },

  created () {
    this.resetForm()
  },

  methods: {
    resetForm () {
      this.forceRerender()
      this.isDisabled = false
      this.payload = {
        first_name: '',
        last_name: '',
        company: '',
        email: '',
        data: {
          interests: []
        }
      }
    },

    forceRerender () {
      this.componentKey += 1
    },

    onExpired () {
      this.isVerified = false
      this.message = null
    },

    clickCheckbox (id) {
      document.getElementById(id).click()
    },

    onVerify (response) {
      this.message = null

      if (response) {
        window.axios.post('/api/recaptcha/verify', {recaptchaResponse: response})
          .then(validateResponse => {
            if (validateResponse.data.success) {
              this.message = null
              this.isVerified = true
              this.isDisabled = false
            } else {
              this.message = 'Invalid captcha'
              this.isVerified = false
              this.isDisabled = false
            }
          })
          .catch(error => {
            this.message = 'Invalid captcha'
            this.isVerified = false
          })
      }
    },

    submitForm () {
      this.isDisabled = true

      if (!this.isVerified) {
        this.message = 'Invalid captcha'
        return
      }

      window.axios.post('/api/newsletter', this.payload)
      .then(response => {
        this.successMessage = "You've successfully subscribed to Newsletter";
        this.isDisabled = false
        this.resetForm()
      })
      .catch((error) => {
        this.isDisabled = false

        if (error.response.status == 422) {
          this.submissionErrors = error.response.data.errors;
        }
      })

    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/NewsLetter.vue